module.exports = __webpack_public_path__ + "images/img-1v9kqUd.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/global/noimage.png
// module id = 2003
// module chunks = 0